import api from "../../index.js";

export const GetAllPromotionByIdApi = (params) => api.get(`PromotionKit/GetAll-PromotionKit?${params}`);
export const GetAllpromotionByIdApi = (id) => api.get(`PromotionKit/GetPromotionKitById/${id}`);